import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import ServiceCueService from "services/servicecue.service";
import HandleError from "../HandleError";
import HandleResponse from "../HandleResponse";

export const ServiceCueStatusApi = createAsyncThunk("servicecue/status", async (_, thunkAPI) => {
  try {
    const resposedata = await ServiceCueService.status()
      .then((response) => HandleResponse(thunkAPI, response, "ServiceCueStatusApi"))
      .catch((error) => HandleError(thunkAPI, error, "ServiceCueStatusApi"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const ServiceCueSetupApi = createAsyncThunk("servicecue/setup", async (_, thunkAPI) => {
  try {
    const resposedata = await ServiceCueService.setup()
      .then((response) => HandleResponse(thunkAPI, response, "ServiceCueSetupApi"))
      .catch((error) => HandleError(thunkAPI, error, "ServiceCueSetupApi"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const ServiceCueRegenerateApi = createAsyncThunk("servicecue/regenerate", async (_, thunkAPI) => {
  try {
    const resposedata = await ServiceCueService.regenerate()
      .then((response) => HandleResponse(thunkAPI, response, "ServiceCueRegenerateApi"))
      .catch((error) => HandleError(thunkAPI, error, "ServiceCueRegenerateApi"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const ServiceCueDisconnectApi = createAsyncThunk("servicecue/disconnect", async (_, thunkAPI) => {
  try {
    const resposedata = await ServiceCueService.disconnect()
      .then((response) => HandleResponse(thunkAPI, response, "ServiceCueDisconnectApi"))
      .catch((error) => HandleError(thunkAPI, error, "ServiceCueDisconnectApi"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

const initialState = {
  isOpenedServiceCueForm: "",
  credentials: null,
  isApiStatus: {
    ServiceCueStatusApi: "",
    ServiceCueSetupApi: "",
    ServiceCueRegenerateApi: "",
    ServiceCueDisconnectApi: "",
  },
};

const servicecueSlice = createSlice({
  name: "servicecue",
  initialState,
  reducers: {
    reset: () => initialState,
    OpenServiceCueForm: (state, action) => {
      state.isOpenedServiceCueForm = action.payload;
    },
    ClearServiceCueSecret: (state) => {
      if (state.credentials) {
        state.credentials = {
          ...state.credentials,
          api_secret: null,
          secret_available: false,
          secret_shown_once: false,
        };
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(ServiceCueStatusApi.pending, (state) => {
        state.isApiStatus = { ...state.isApiStatus, ServiceCueStatusApi: "loading" };
      })
      .addCase(ServiceCueStatusApi.fulfilled, (state, action) => {
        state.isApiStatus = { ...state.isApiStatus, ServiceCueStatusApi: "succeeded" };
        state.credentials = {
          ...(action.payload || {}),
          api_secret: null,
          secret_available: false,
          secret_shown_once: false,
        };
      })
      .addCase(ServiceCueStatusApi.rejected, (state) => {
        state.isApiStatus = { ...state.isApiStatus, ServiceCueStatusApi: "failed" };
      })
      .addCase(ServiceCueSetupApi.pending, (state) => {
        state.isApiStatus = { ...state.isApiStatus, ServiceCueSetupApi: "loading" };
      })
      .addCase(ServiceCueSetupApi.fulfilled, (state, action) => {
        state.isApiStatus = { ...state.isApiStatus, ServiceCueSetupApi: "succeeded" };
        state.credentials = action.payload || null;
      })
      .addCase(ServiceCueSetupApi.rejected, (state) => {
        state.isApiStatus = { ...state.isApiStatus, ServiceCueSetupApi: "failed" };
      })
      .addCase(ServiceCueRegenerateApi.pending, (state) => {
        state.isApiStatus = { ...state.isApiStatus, ServiceCueRegenerateApi: "loading" };
      })
      .addCase(ServiceCueRegenerateApi.fulfilled, (state, action) => {
        state.isApiStatus = { ...state.isApiStatus, ServiceCueRegenerateApi: "succeeded" };
        state.credentials = action.payload || null;
      })
      .addCase(ServiceCueRegenerateApi.rejected, (state) => {
        state.isApiStatus = { ...state.isApiStatus, ServiceCueRegenerateApi: "failed" };
      })
      .addCase(ServiceCueDisconnectApi.pending, (state) => {
        state.isApiStatus = { ...state.isApiStatus, ServiceCueDisconnectApi: "loading" };
      })
      .addCase(ServiceCueDisconnectApi.fulfilled, (state) => {
        state.isApiStatus = { ...state.isApiStatus, ServiceCueDisconnectApi: "succeeded" };
        state.credentials = null;
        state.isOpenedServiceCueForm = "";
      })
      .addCase(ServiceCueDisconnectApi.rejected, (state) => {
        state.isApiStatus = { ...state.isApiStatus, ServiceCueDisconnectApi: "failed" };
      });
  },
});

export const { reset, OpenServiceCueForm, ClearServiceCueSecret } = servicecueSlice.actions;
export default servicecueSlice.reducer;
